export default `
     ██╗   ██╗ ██████╗ ██╗   ██╗  
     ╚██╗ ██╔╝██╔═══██╗██║   ██║  [ , , , ,*, , , ]
  [*, , , , , ,*, ]   ╚████╔╝ ██║   ██║██║   ██║ [ ,*, , , , , , ] 
       ╚██╔╝  ██║   ██║██║   ██║    [ ,*, , , , , , ]
      [ , , , ,*, , , ] ██║   ╚██████╔╝╚██████╔╝  
        ╚═╝    ╚═════╝  ╚═════╝   [ , ,*, , , , , ]
    ██╗    ██╗ ██████╗ ███╗   ██╗
  [*, , , , , , ,*] ██║    ██║██╔═══██╗████╗  ██║ [ ,*, , , , , , ]
    ██║ █╗ ██║██║   ██║██╔██╗ ██║
    ██║███╗██║██║   ██║██║╚██╗██║ [ , , ,*, , , , ]
    ╚███╔███╔╝╚██████╔╝██║ ╚████║
     ╚══╝╚══┏┓┏┓┏┓┳┓┏┓ ╚═╝  ╚═══╝                    
     [ , , , ,*, , , ]      ┗┓┃ ┃┃┣┫┣ $score   
     [ ,*, , , , , , ]      ┗┛┗┛┗┛┛┗┗┛   
                               
`

